export default __webpack_public_path__ + "static/media/docs-cortisol-chemical-formula.1b9ddaf8.png";